import {
    Button,
    Form,
    FormGroup,
    Input,
    Label,
    Modal,
    ModalBody,
    FormFeedback,
    ModalHeader,
} from "reactstrap";
import {useContext, useState} from "react";
import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import {toast} from "react-toastify";
import Loader from "../../components/Loader";
import AuthContext from "../../context/AuthContext";
import handleUnauthorized401MutateError from "../../utils/handleUnauthorized401MutateError";
import {addAddOnProducts, getProducts} from "../../api/api";
import Select from "react-select";
import handleUnauthorized401QueryError from "../../utils/handleUnauthorized401QueryError";

const AddAddOnProductButton = () => {
    const {refreshToken} = useContext(AuthContext)
    const [addAddOnProductModal, setAddAddOnProductModal] = useState(false);
    const toggleAddAddOnProductModal = () =>
        setAddAddOnProductModal(!addAddOnProductModal);
    const [addOnProductName, setAddOnProductName] = useState('');
    const [addOnProductPrice, setAddOnProductPrice] = useState('');
    const [addOnProductDescription, setAddOnProductDescription] = useState('');
    const [addOnProductUPC, setAddOnProductUPC] = useState('');
    const [addOnProductIsDigital, setAddOnProductIsDigital] = useState(false);
    const [addOnProductStock, setAddOnProductStock] = useState('');
    const [addOnProductImage, setAddOnProductImage] = useState('');
    const [addOnProductIsInventoryTrackingEnabled, setAddOnProductIsInventoryTrackingEnabled] = useState(false);
    // const [addOnProductTaxType, setAddOnProductTaxType] = useState('');
    // const [addOnProductTaxPercentage, setAddOnProductTaxPercentage] = useState('');
    const [productsSupported, setProductsSupported] = useState('');
    const [productOptions, setProductOptions] = useState([]);
    const [addOnProductRecords, setAddOnProductRecords] = useState(1);
    const [advancedOptions, setAdvancedOptions] = useState(false);

    const onSelect = (event) => {
        let newArr = []
        for(let i=0; i < event.length; i++){
            newArr.push(event[i].value)
            setProductsSupported(newArr)
        }
        setProductsSupported(newArr)
    };

    const queryClient = useQueryClient()

    const { refetch } = useQuery({
        queryKey: ['products', addOnProductRecords],
        queryFn: () => getProducts(1,'', '','','', '', '','',
            '', '','', '', '', '', '', addOnProductRecords),
        keepPreviousData : true,
        retry: false,
        refetchOnWindowFocus: false,
        enabled: addAddOnProductModal,
        onSuccess: (data =>{
            setAddOnProductRecords(data?.count)
            let newOptions = []
            for(let i=0; i<data?.results?.length; i++){
                newOptions.push({value:data?.results[i].name, label:data?.results[i].name})
            }
            setProductOptions(newOptions)
        }),
        onError: (err => {
            handleUnauthorized401QueryError(err, refreshToken, refetch)
            if(err.response.status !== 401){
                toast.error(`An error occurred! ${err?.response?.data?.detail}`)
            }
        })
    })

    const addAddOnProductMutation = useMutation({
        mutationFn: addAddOnProducts,
        onSuccess: () =>{
            toggleAddAddOnProductModal()
            queryClient.invalidateQueries(['add-on-products'])
            setAddOnProductName('')
            setAddOnProductPrice('')
            setAddOnProductDescription('')
            setAddOnProductIsDigital(false)
            setAddOnProductStock('')
            setAddOnProductImage('')
            setAddOnProductIsInventoryTrackingEnabled('')
            setAdvancedOptions(false);
            toast.success('Add-On Product Added!')
        },
        onError: (err, variables) => {
            handleUnauthorized401MutateError(err, refreshToken, addAddOnProductMutation, variables)
            if(err.response.status !== 401){
                toast.error(`An error occurred! ${err?.response?.data?.detail}`)
            }
        }
    })

    const handleAddAddOnProductFormSubmit = async (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append("name", addOnProductName);
        if(productsSupported) productsSupported.forEach(product => {formData.append("products", product)})
        formData.append("price", addOnProductPrice);
        formData.append("description", addOnProductDescription);
        formData.append("upc", addOnProductUPC);
        // formData.append("tax_type", addOnProductTaxType);
        // formData.append("tax_percentage", addOnProductTaxPercentage);
        formData.append("is_digital", addOnProductIsDigital);
        formData.append("is_inventory_tracking_enabled", addOnProductIsInventoryTrackingEnabled)
        formData.append("stock", addOnProductStock);
        formData.append("is_advanced_options", advancedOptions);
        if (addOnProductImage) formData.append("image", addOnProductImage);
        addAddOnProductMutation.mutate(formData)
    };

    return (
        <>
            <div className="fileupload btn bx-btn-primary waves-effect waves-light mb-3" onClick={toggleAddAddOnProductModal}>
                <span><i className="mdi mdi-plus-circle mr-1"/>Add Product Add-On</span>
            </div>
            <Modal isOpen={addAddOnProductModal} toggle={toggleAddAddOnProductModal} backdrop="static" keyboard={false}>
                <ModalHeader toggle={toggleAddAddOnProductModal} close={
                    <button className="close" onClick={toggleAddAddOnProductModal}>
                        &times;
                    </button>}>Add Product Add-On</ModalHeader>
                <ModalBody>
                    <Form onSubmit={handleAddAddOnProductFormSubmit}>
                        <FormGroup>
                            <Label for="name">Name<span className="text-danger">*</span></Label>
                            <Input
                                type="text"
                                name="add-on-product-name"
                                id="add-on-product-name"
                                placeholder="Add-On Product name"
                                value={addOnProductName}
                                onChange={(e) => setAddOnProductName(e.target.value)}
                                // invalid={true}

                                invalid={
                                    addAddOnProductMutation.isError &&
                                    addAddOnProductMutation.error.response.data.name
                                }
                            />
                            {addAddOnProductMutation.isError && addAddOnProductMutation.error.response.data.name && (
                                <FormFeedback invalid>
                                    {addAddOnProductMutation.error.response.data.name}
                                </FormFeedback>
                            )}
                        </FormGroup>
                        <FormGroup>
                            <Label for="products-supported">
                                Select The Products That Supports This Add-On
                                <span className="text-danger">*</span>
                            </Label>
                            <Select
                                options={productOptions}
                                isMulti
                                noOptionsMessage = {() => "No Product(s) found!"}
                                placeholder = "Select Products..."
                                onChange={e => onSelect(e)}
                                styles={{
                                    control: (baseStyles) => (
                                        {
                                            ...baseStyles,
                                            borderColor: "#495561",
                                            backgroundColor: "#414d59",
                                            color: "white",
                                            padding: "0.45 0.9",
                                            border: 'none',
                                            boxShadow: 'none'
                                        }
                                    ),
                                    menu: (baseStyles) => (
                                        {
                                            ...baseStyles,
                                            backgroundColor: "#414d59",
                                            color: "#a8b5c3"
                                        }
                                    ),
                                    input: (baseStyles) => (
                                        {
                                            ...baseStyles,
                                            color: "white"
                                        }
                                    )
                                }}

                            />
                        </FormGroup>
                        <FormGroup>
                            <Label for="add-on-product-price">Price<span className="text-danger">*</span></Label>
                            <Input
                                type="text"
                                min="1"
                                step="any"
                                name="add-on-product-price"
                                id="add-on-product-price"
                                placeholder="Add-On Product Price"
                                value={addOnProductPrice}
                                onChange={(e) => setAddOnProductPrice(e.target.value)}
                                invalid={
                                    addAddOnProductMutation.isError &&
                                    addAddOnProductMutation.error.response.data.price
                                }
                            />
                            {addAddOnProductMutation.isError && addAddOnProductMutation.error.response.data.price && (
                                <FormFeedback invalid>
                                    {addAddOnProductMutation.error.response.data.price}
                                </FormFeedback>
                            )}
                        </FormGroup>
                        <FormGroup className="form-group mb-3">
                            <div className="custom-control custom-checkbox">
                                <Input
                                    type="checkbox"
                                    className="custom-control-input"
                                    id="checkbox-advanced-options"
                                    checked={advancedOptions}
                                    onChange={() => setAdvancedOptions(!advancedOptions)}
                                />
                                <Label
                                    className="custom-control-label"
                                    for="checkbox-advanced-options"
                                >
                                    Advanced Options
                                </Label>
                            </div>
                        </FormGroup>
                        {advancedOptions&& (
                            <FormGroup>
                                <Label for="add-on-product-description">Description</Label>
                                <Input
                                    type="textarea"
                                    name="add-on-product-description"
                                    id="add-on-product-description"
                                    value={addOnProductDescription}
                                    placeholder="Add-On Product Description"
                                    onChange={(e) => setAddOnProductDescription(e.target.value)}
                                    invalid={
                                        addAddOnProductMutation.isError &&
                                        addAddOnProductMutation.error.response.data.description
                                    }
                                />
                                {addAddOnProductMutation.isError && addAddOnProductMutation.error.response.data.description && (
                                    <FormFeedback invalid>
                                        {addAddOnProductMutation.error.response.data.description}
                                    </FormFeedback>
                                )}
                            </FormGroup>
                        )}
                        {advancedOptions&& (
                            <FormGroup>
                                <Label for="UPC">UPC</Label>
                                <Input
                                    type="text"
                                    name="UPC"
                                    id="add-on-product-upc"
                                    value={addOnProductUPC}
                                    placeholder="Add-On Product UPC"
                                    onChange={(e) => setAddOnProductUPC(e.target.value)}
                                    invalid={
                                        addAddOnProductMutation.isError &&
                                        addAddOnProductMutation.error.response.data.upc
                                    }
                                />
                                {addAddOnProductMutation.isError && addAddOnProductMutation.error.response.data.upc && (
                                    <FormFeedback invalid>
                                        {addAddOnProductMutation.error.response.data.upc}
                                    </FormFeedback>
                                )}
                            </FormGroup>
                            )}
                        {advancedOptions&& (
                            <FormGroup className="form-group mb-3">
                                <div className="custom-control custom-checkbox">
                                    <input
                                        type="checkbox"
                                        className="custom-control-input"
                                        id="checkbox-digital"
                                        checked={addOnProductIsDigital}
                                        onChange={() => setAddOnProductIsDigital(!addOnProductIsDigital)}
                                            invalid={
                                                addAddOnProductMutation.isError &&
                                                addAddOnProductMutation.error.response.data.is_digital
                                            }
                                    />
                                    <Label
                                        className="custom-control-label"
                                            for="checkbox-digital"
                                    >
                                        Digital Add-On Product
                                    </Label>
                                </div>
                                {addAddOnProductMutation.isError && addAddOnProductMutation.error.response.data.is_digital && (
                                    <FormFeedback invalid>
                                        {addAddOnProductMutation.error.response.data.is_digital}
                                    </FormFeedback>
                                )}
                            </FormGroup>
                        )}
                        {/*{advancedOptions&& (*/}
                        {/*    <FormGroup className="form-group">*/}
                        {/*        <Label for="add-on-product-tax-type">Tax Type</Label>*/}
                        {/*        <Input*/}
                        {/*            type="select"*/}
                        {/*            name="add-on-product-tax-type"*/}
                        {/*            id="add-on-product-tax-type"*/}
                        {/*            className="form-control mb-2"*/}
                        {/*            placeholder="Add-On Product Tax-type"*/}
                        {/*            value={addOnProductTaxType}*/}
                        {/*            onChange={(e) => setAddOnProductTaxType(e.target.value)}*/}
                        {/*        >*/}
                        {/*            <option value="">--</option>*/}
                        {/*            <option value={"TAX-INCLUSIVE"}>*/}
                        {/*                Tax Inclusive*/}
                        {/*            </option>*/}
                        {/*            <option value={"TAX-EXCLUSIVE"}>*/}
                        {/*                Tax Exclusive*/}
                        {/*            </option>*/}
                        {/*        </Input>*/}
                        {/*        {addAddOnProductMutation.isError && addAddOnProductMutation.error.response.data.tax_type && (*/}
                        {/*            <FormFeedback invalid>*/}
                        {/*                {addAddOnProductMutation.error.response.data.tax_type}*/}
                        {/*            </FormFeedback>*/}
                        {/*        )}*/}
                        {/*    </FormGroup>*/}
                        {/*)}*/}
                        {/*{advancedOptions&& (*/}
                        {/*    <FormGroup>*/}
                        {/*        <Label for="add-on-product-tax">Tax Percentage</Label>*/}
                        {/*        <Input*/}
                        {/*            type="text"*/}
                        {/*            name="add-on-product-tax-percentage"*/}
                        {/*            id="add-on-product-tax-percenrage"*/}
                        {/*            placeholder="Add-On Product Tax-percentage"*/}
                        {/*            value={addOnProductTaxPercentage}*/}
                        {/*            onChange={(e) => setAddOnProductTaxPercentage(e.target.value)}*/}
                        {/*            invalid={*/}
                        {/*                addAddOnProductMutation.isError &&*/}
                        {/*                addAddOnProductMutation.error.response.data.tax_percentage*/}
                        {/*            }*/}
                        {/*        />*/}
                        {/*        {addAddOnProductMutation.isError && addAddOnProductMutation.error.response.data.tax_percentage && (*/}
                        {/*            <FormFeedback invalid>*/}
                        {/*                {addAddOnProductMutation.error.response.data.tax_percentage}*/}
                        {/*            </FormFeedback>*/}
                        {/*        )}*/}
                        {/*    </FormGroup>*/}
                        {/*    )}*/}
                        {advancedOptions&& (
                            <FormGroup className="form-group mb-3">
                                <div className="custom-control custom-checkbox">
                                    <Input
                                        type="checkbox"
                                        className="custom-control-input"
                                        id="checkbox-inventory-tracking"
                                        checked={addOnProductIsInventoryTrackingEnabled}
                                        onChange={() => setAddOnProductIsInventoryTrackingEnabled(!addOnProductIsInventoryTrackingEnabled)}
                                        invalid={
                                            addAddOnProductMutation.isError &&
                                            addAddOnProductMutation.error.response.data.is_inventory_tracking_enabled
                                        }
                                    />
                                    <Label
                                        className="custom-control-label"
                                        for="checkbox-inventory-tracking"
                                    >
                                        Inventory Tracking
                                    </Label>
                                    {addAddOnProductMutation.isError && addAddOnProductMutation.error.response.data.is_inventory_tracking_enabled && (
                                        <FormFeedback invalid>
                                            {addAddOnProductMutation.error.response.data.is_inventory_tracking_enabled}
                                        </FormFeedback>
                                    )}
                                </div>
                            </FormGroup>
                        )}
                        {addOnProductIsInventoryTrackingEnabled&& advancedOptions&& (
                            <FormGroup>
                                <Label for="stock">Stock</Label>
                                <Input
                                    type="number"
                                    name="stock"
                                    id="stock"
                                    placeholder="Add-On Product Initial Stock Value"
                                    value={addOnProductStock}
                                    onChange={(e) => setAddOnProductStock(e.target.value)}
                                    invalid={
                                        addAddOnProductMutation.isError &&
                                        addAddOnProductMutation.error.response.data.stock
                                    }
                                />
                                {addAddOnProductMutation.isError && addAddOnProductMutation.error.response.data.stock && (
                                    <FormFeedback invalid>
                                        {addAddOnProductMutation.error.response.data.stock}
                                    </FormFeedback>
                                )}
                            </FormGroup>
                        )}
                        <FormGroup>
                            <Label for="image">Image</Label>
                            <Input
                                type="file"
                                name="productImage"
                                id="productImage"
                                onChange={(e) => setAddOnProductImage(e.target.files[0])}
                                invalid={
                                    addAddOnProductMutation.isError &&
                                    addAddOnProductMutation.error.response.data.image
                                }
                            />
                            {addAddOnProductMutation.isError && addAddOnProductMutation.error.response.data.image && (
                                <FormFeedback invalid>
                                    {addAddOnProductMutation.error.response.data.image}
                                </FormFeedback>
                            )}
                        </FormGroup>
                        <Button
                            color="#4d5bed"
                            className="bx-btn-primary"
                            block
                            disabled={addAddOnProductMutation.isLoading}
                        >
                            {addAddOnProductMutation.isLoading? <><Loader size={'small'}/> Adding Add-On Product...</>: `Add Product Add-On`}
                        </Button>
                    </Form>
                </ModalBody>
            </Modal>
        </>
    );
};

export default AddAddOnProductButton;